import { DayHeaderContentArg } from '@fullcalendar/core'
import { isToday } from 'date-fns'
import dayjs from 'dayjs'

export function dayHeaderClassNames(e: DayHeaderContentArg) {
  return isToday(dayjs(e.date).add(13, 'hour').toDate())
    ? 'FullCalendarHeaderCurrentDay'
    : ''
}
